import { getStoreValue, stores } from "../utils/store";
import { addTaskRequest, doneTaskRequest, editTaskRequest, getTasksRequest, removeTaskRequest } from "./endpoints/task";
import { handleSkillRewards, SkillProps } from "./skill";
import { keyBy } from "../utils/utils";

export interface TaskRewardProps {
    xp: number,
    type: SkillProps['id'],
}

export enum TaskType {
    GOAL, //goals, tasks that consist of multipel tasks, big ones with profit in future
    REPETITIVE, //daily tasks, chores, repetitive
    ONEOFF, //one off tasks, simply something to do once and then its logicaly done
}

export enum TaskOrientation {
    VERTICAL, HORIZONTAL
}

export enum TaskDifficulty {
    LVL_0, LVL_1, LVL_2, LVL_3, LVL_4
}

export const taskDIfficultyDisplayNames = {
    [TaskDifficulty.LVL_0]: 'Comfort Zone', //thinggs you liek and enjoy, no effort
    [TaskDifficulty.LVL_1]: 'Walk in Park', //just like ... at first hard (hard to start) then enjoyable and not that bad
    [TaskDifficulty.LVL_2]: 'Attack of Duck', //fiersome, but given neough effort  you might become best friends one day
    [TaskDifficulty.LVL_3]: 'Claiming to Top', //hard to start, hard to do, but view and contentfulness at end is impeccable
    [TaskDifficulty.LVL_4]: 'Chilli Pepper', //dont want to do, once you do it its not easier, and only tears after
}

const taskDifficultyIcons = {
    [TaskDifficulty.LVL_0]: 'difficulty-lvl-0v3',
    [TaskDifficulty.LVL_1]: 'difficulty-lvl-1',
    [TaskDifficulty.LVL_2]: 'difficulty-lvl-2',
    [TaskDifficulty.LVL_3]: 'difficulty-lvl-3',
    [TaskDifficulty.LVL_4]: 'difficulty-lvl-4',
}

export const taskTypeDisplayName = {
    [TaskType.GOAL]: 'Goal',
    [TaskType.REPETITIVE]: 'Daily',
    [TaskType.ONEOFF]: 'Once',
}

export function getTaskDifficultyDisplayName(difficulty?: TaskDifficulty): string {
    if (difficulty === undefined) return 'unknown';
    return taskDIfficultyDisplayNames[difficulty];
}

export function getTaskDifficultyIcon(difficulty?: TaskDifficulty): string {
    if (difficulty === undefined) return 'difficulty-unknown2';
    return taskDifficultyIcons[difficulty];
}


export function getTaskTypeDisplayName(type: TaskType): string {
    return taskTypeDisplayName[type];
}

export interface TaskProps {
    id: number,
    name: string,
    type: TaskType,
    date: number | string,
    duration?: number,
    difficulty?: TaskDifficulty,
    order: number,
    children?: TaskProps['id'][],
    parent?: TaskProps['id'],
    rewards: TaskRewardProps[],
    description?: string,
    done?: boolean,
}

let loadPromise: Promise<boolean>;

export function loadTasks(): Promise<boolean> {
    if (!loadPromise) loadPromise = getTasksRequest().then((tasks) => stores.tasks.set(tasks)).then(() => { stores.tasksByName.set(keyBy(getStoreValue(stores.tasks), 'name')) }).then();
    return loadPromise;
}

export function addTask(task: TaskProps) {
    const copyOfTasks = [...getStoreValue(stores.tasks)];
    task.id = Math.round(Math.random() * 10000000000);
    copyOfTasks.push(task);
    stores.tasks.set(copyOfTasks);

    addTaskRequest(task);
}

export function editTask(task: TaskProps) {
    const copyOfTasks = [...getStoreValue(stores.tasks)];
    const index = copyOfTasks.findIndex((currentTask) => currentTask.id === task.id);
    copyOfTasks[index] = task;
    stores.tasks.set(copyOfTasks);

    editTaskRequest(task);
}

export function removeTask(id: TaskProps['id']) {
    const copyOfTasks = [...getStoreValue(stores.tasks)];
    const index = copyOfTasks.findIndex((currentTask) => currentTask.id === id);
    copyOfTasks.splice(index, 1);
    stores.tasks.set(copyOfTasks);

    removeTaskRequest(id);
}

export function doneTask(id: TaskProps['id']) {
    const copyOfTasks = [...getStoreValue(stores.tasks)];
    const index = copyOfTasks.findIndex((currentTask) => currentTask.id === id);
    if (copyOfTasks[index].done) return;
    copyOfTasks[index].done = true;
    stores.tasks.set(copyOfTasks);

    handleRewards(copyOfTasks[index].rewards);
    doneTaskRequest(id);
}

function handleRewards(rewards: TaskProps['rewards']) {
    handleSkillRewards(rewards);


}